import { css } from 'styled-components';

const extraSmall = () => css`
  height: 20px;
  padding: 3px 8px;
`;

export { extraSmall };
